const ENCanvasModels = {
	"Ao menos um quadrante deve ser informado": "At least one quadrant must be read",
	"Adicionar Quadrante": "Add Quadrant",
	"Adicionar Modelo CANVAS": "Add CANVAS Models",
	"Alterar Modelo CANVAS": "Change CANVAS Models",
	"Criar novo Modelo CANVAS": "Create new CANVAS Models",
	"Código": "Code",
	"Código é requerido": "Code is required",
	"Cor": "Color",
	"Deseja realmente excluir o modelo": "Do you really want to delete the model",
	"Erro ao adicionar modelo": "Error on adding model",
	"Erro ao alterar modelo": "Error on changing model",
	"Erro ao excluir modelo": "Error on deleting model",
	"Excluir Quadrante": "Delete Quadrant",
	"Exclusão do modelo": "Delete model",
	"Descrição é requerida": "Description is required",
	"Quadrantes": "Quadrants",
	"Novo modelo CANVAS": "New CANVAS model",
	"Modelos CANVAS": "CANVAS Models",
	"Modelos de canvas": "Canvas models",
	"Modelo adicionado com sucesso": "Model successfully added",
	"Modelo alterado com sucesso": "Model successfully changed",
	"Modelo excluído com sucesso": "Model successfully deleted"
};

export default ENCanvasModels;
